module.exports = __webpack_public_path__ + "img/shape-bg.b7ac9274.svg";